<template>
  <div class="slider" :class="{ 'team-root-loading' : teamRootLoading }">
    <div class="line" />
    <div class="subline inc" />
    <div class="subline dec" />
  </div>
</template>

<script>
export default {
  name: 'HorizontalLoading',
  props: {
    teamRootLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  overflow-x: hidden;

  &.team-root-loading {
    top: -5px;
  }
}

.line {
  position: absolute;
  width: 150%;
  height: 5px;
  background: #4a8df8;
  opacity: 0.4;
}

.subline {
  position: absolute;
  height: 5px;
  background: #4a8df8;
}

.inc {
  animation: increase 2s infinite;
}

.dec {
  animation: decrease 2s 0.5s infinite;
}

@keyframes increase {
  from {
    left: -5%;
    width: 5%;
  }

  to {
    left: 130%;
    width: 100%;
  }
}

@keyframes decrease {
  from {
    left: -80%;
    width: 80%;
  }

  to {
    left: 110%;
    width: 10%;
  }
}
</style>
